interface FormProgressProps {
  steps: string[];
  current: number;
  // completed[i] = true means the step passes all validation and shows ✓.
  // visited (i < current) keeps the step clickable regardless of completion.
  completed: boolean[];
  onGoTo?: (index: number) => void;
}

export default function FormProgress({ steps, current, completed, onGoTo }: FormProgressProps) {
  return (
    // padding ensures outline ring is never clipped by the overflow scroll container
    <div style={{ display: 'flex', alignItems: 'center', gap: 0, overflowX: 'auto', padding: '6px 4px 6px 4px' }}>
      {steps.map((_label, i) => {
        const done      = completed[i] ?? false;
        const active    = i === current;
        const bg      = done ? 'var(--primary)' : active ? 'var(--accent)' : 'var(--muted)';
        const textCol = done || active ? '#fff' : 'var(--muted-foreground)';
        return (
          <div key={i} style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
            <button
              onClick={() => onGoTo?.(i)}
              title={`Ugrás: ${_label}`}
              style={{
                width: 28, height: 28, borderRadius: '50%', border: 'none',
                background: bg, color: textCol, fontSize: 11, fontWeight: 700,
                cursor: 'pointer', flexShrink: 0,
                // outline never clips in overflow containers; follows border-radius in modern browsers
                outline: active ? '2px solid var(--accent)' : 'none',
                outlineOffset: active ? '3px' : '0',
              }}
            >
              {done ? '✓' : i + 1}
            </button>
            {i < steps.length - 1 && (
              <div style={{ width: 24, height: 2, background: i < current ? 'var(--primary)' : 'var(--border)', flexShrink: 0 }} />
            )}
          </div>
        );
      })}
    </div>
  );
}
